import { render, staticRenderFns } from "./restbookset.vue?vue&type=template&id=418a9c24&scoped=true&"
import script from "./restbookset.vue?vue&type=script&lang=js&"
export * from "./restbookset.vue?vue&type=script&lang=js&"
import style0 from "./restbookset.vue?vue&type=style&index=0&id=418a9c24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418a9c24",
  null
  
)

export default component.exports